import {
  IFillDataWizardBuy,
  TBooleanKeysOfIFillDataWizardBuy,
  TKeyOfDataWizardBuy,
  TNumberKeysOfIFillDataWizardBuy,
  TStringKeysOfIFillDataWizardBuy,
} from "../..";
import WishStep_1 from "../wishSteps/step_1";
import WishStep_2 from "../wishSteps/step_2";
import WishStep_3 from "../wishSteps/step_3";
import WishStep_4 from "../wishSteps/step_4";
import WishStep_5 from "../wishSteps/step_5";
import WishStep_6 from "../wishSteps/step_6";
import WishStep_7 from "../wishSteps/step_7";
import WishStep_8 from "../wishSteps/step_8";
import WishStep_9 from "../wishSteps/step_9";

const getWishSteps = (
  data: IFillDataWizardBuy,
  handleChangeDataNumber: (
    data: number | number[],
    key: TNumberKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataBoolean: (
    data: boolean,
    key: TBooleanKeysOfIFillDataWizardBuy
  ) => void,
  handleChangeDataString: (
    data: string,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void,
  onReset: (key: TKeyOfDataWizardBuy[]) => void,
  disabledAndPrev: {
    isNextStepDisabled_selectedPolygonIds: boolean;
    isNextStepDisabled_selectedTypeIds: boolean;
    isNextStepDisabled_finance: boolean;
    isNextStepDisabled_aim: boolean;
    isTriplePrevSteps: boolean;
  }
) => {
  // если не знает что хочет преобрести и решил пройти опрос

  const {
    isNextStepDisabled_selectedPolygonIds,
    isNextStepDisabled_selectedTypeIds,
    isNextStepDisabled_finance,
    isNextStepDisabled_aim,
    isTriplePrevSteps,
  } = disabledAndPrev;

  return [
    <WishStep_1
      isNextStepDisabled={isNextStepDisabled_selectedPolygonIds}
      onChange={handleChangeDataNumber}
      data={data.desiredLocationIds}
      onReset={onReset}
    />,
    <WishStep_2
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      onReset={onReset}
    />,
    <WishStep_3
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <WishStep_4
      isNextStepDisabled={isNextStepDisabled_selectedTypeIds}
      onChange={handleChangeDataNumber}
      data={data.selectedFacilityTypeIds}
      onReset={onReset}
    />,
    <WishStep_5
      typeIds={data.selectedFacilityTypeIds}
      selectedPolygonIds={data.desiredLocationIds}
    />,
    <WishStep_6
      isNextStepDisabled={isNextStepDisabled_finance}
      data={data.finance}
      onChange={handleChangeDataBoolean}
      triplePrevStep={isTriplePrevSteps}
      onReset={onReset}
    />,
    <WishStep_7
      isNextStepDisabled={isNextStepDisabled_aim}
      onChange={handleChangeDataString}
      data={data.aim}
      onReset={onReset}
    />,
    <WishStep_8 />,
    <WishStep_9 />,
  ];
};

export default getWishSteps;
